export const MAPBOXDATA = {
    TOKEN: 'pk.eyJ1IjoiamdhdXRpZXItZXV0ZWxzYXQiLCJhIjoiY2wwZ3JpdnQxMDBxeTNjbm00MHVsYTRxcCJ9.5pEf7gFtrQagRmOhLYieLQ',
    LAYER: 'https://api.mapbox.com/styles/v1/jgautier-eutelsat/cl0rxsbak000p14o1rrg730un/tiles/256/{z}/{x}/{y}?access_token='
  };
  